export default __webpack_public_path__ + "static/media/business_show_1.e305b9cc.png";